import React, { Component } from "react"
import ThemeContext from "shared/context"

import "./footer.scss"

class Footer extends Component {
  render() {
    return (
      <div className={`c-Footer${this.context.theme === 'light' ? ' c-Footer--light' : ''}`}>
        <div className="c-Footer-address">
          <span className="c-Footer-addressStreet">AM FRUCHTKASTEN 3</span>
          <span className="c-Footer-addressCity">70173 STUTTGART</span>
        </div>
        <div className="c-Footer-contact">
          <span className="c-Footer-contactPhone">+49 (0) 711 2539 0110</span>
          <span className="c-Footer-contactMail">WHO@CITIZENLONG.COM</span>
        </div>
      </div>
    )
  }
}

Footer.contextType = ThemeContext
export default Footer